<template>
  <profile-card header-color="blue" class="map-sidebar">
    <template slot="header">
      <div class="card-icon"><md-icon>location_on</md-icon></div>
    </template>
    <template slot="content">
      <div class="info-wrap">
        <p  class="sidebar-title h5-p">
          Map Center Point
        </p>
        <label class="sidebar-title-label">(Optional)</label>
      </div>
      <md-field>
        <label>Street Address</label>
        <md-input v-model="streetAddress" type="text"></md-input>
      </md-field>
      <md-field>
        <label>ZIP Code</label>
        <md-input v-model="zipCode" type="text"></md-input>
      </md-field>
      <md-field>
        <label>Radius, max 100 miles</label>
        <md-input v-model="radius" type="text"></md-input>
      </md-field>
    </template>
    <template slot="footer">
      <md-button class="md-info md-block access-button btn-sm" @click="access"
        >Calculate
      </md-button>
    </template>
  </profile-card>
</template>

<script>
import { ProfileCard } from '@/components';
import axios from 'axios';

export default {
  name: 'sidebar-map',
  props: {},
  components: { ProfileCard },
  data() {
    return {
      streetAddress: '',
      zipCode: '',
      radius: '',
    };
  },
  methods: {
    getData: function(name) {
      if (name) {
        return name.split('[')[1].split(']')[0];
      }
    },
    access: async function() {
      if (this.streetAddress && this.zipCode && this.radius) {
        let currentSession = localStorage.getItem(
          'vue-authenticate.vueauth_access_token'
        );

        this.$store.commit(
          'C_SET_MARKET_AREA',
          `${this.radius} miles away from ${this.streetAddress}, ${this.zipCode} [map_center]`
        );
        // });
      }
    },
  },
  computed: {
    profileId() {
      return this.$store.getters.cProfileId;
    },
  },
};
</script>
<style lang="scss"></style>
